<template>
  <!-- Same markup as the boot screen in index.html (its styles live there), so the hand-off from the static page
       to Vue doesn't flicker. Shown until the first route's guards and chunk resolve. -->
  <div class="boot-screen" role="status" aria-label="Cargando">
    <div class="boot-screen__mark">
      <div class="boot-screen__ring"></div>
      <div class="boot-screen__ring boot-screen__ring--late"></div>
      <img class="boot-screen__logo" src="@/assets/logoMarkWhite.svg" alt="Ruta Segura" />
    </div>
    <div class="boot-screen__caption">{{ caption }}</div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'AppBootScreen',
  props: {
    caption: { type: String, default: '' }
  }
})
</script>
